/** @jsx jsx */
import React from 'react'
import { renderReact } from '@frontend/utils/react-compat'
import { css, jsx } from '@emotion/react'
import { Map } from './Map'

const MapContainer = () => {
  const top = 'var(--top-banner-offset, 0px)'

  // apiKeyの取得
  const [apiKey, setApiKey] = React.useState<string | null>(null)

  React.useEffect(() => {
    const dataElement = document.querySelector('#data')
    const key = dataElement && dataElement.getAttribute('data-mapApiKey')
    setApiKey(key)
  }, [])

  return (
    <div css={mapContainerStyle(top)}>{apiKey && <Map apiKey={apiKey} />}</div>
  )
}

document.addEventListener('DOMContentLoaded', () => {
  renderReact(<MapContainer />, document.getElementById('react_map'))
})

const mapContainerStyle = (top: string) => css`
  position: absolute;
  top: ${top};
  right: 0;
  left: 0;
  /* bottom: 61px; // bottom navigation の高さ */
  bottom: 0; // いったんフッターを従来のものに戻す
  margin: auto;
  @media screen and (min-width: 1024px) {
    max-width: 70%;
  }
`
